import type React from 'react';
import { DocumentTitleHelper } from './DocumentTitleContainer.tsx';

type DocumentTitleProps = {
	title: string;
};

export const DocumentTitle: (props: DocumentTitleProps) => React.ReactNode = DocumentTitleHelper;
